module.exports = __webpack_public_path__ + "static/media/big_hand.d092c363.png";